var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3907 2.40381H21.7642L14.3942 10.8273L23.0645 22.2898H16.2757L10.9585 15.3378L4.8744 22.2898H1.49889L9.38189 13.2799L1.06445 2.40381H8.02556L12.8318 8.75814L18.3907 2.40381ZM17.2068 20.2706H19.076L7.00985 4.31694H5.00391L17.2068 20.2706Z",
    fill: "#043873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.abf3500681feb56295e259bc78c99be5.svg";
export { ForwardRef as ReactComponent };